import VectorImage_VectorButtonComponent from '../components/VectorImage/viewer/skinComps/VectorButton/VectorButton.skin';
import VectorImage_VectorButtonController from '../components/VectorImage/viewer/VectorImage.controller';


const VectorImage_VectorButton = {
  component: VectorImage_VectorButtonComponent,
  controller: VectorImage_VectorButtonController
};


export const components = {
  ['VectorImage_VectorButton']: VectorImage_VectorButton
};

